import SurveyHeaderWrapper from './SurveyHeaderWrapper';
import BackLink from './BackLink';
import { getUsefulVars } from '../../../handlers/helpers';

const SurveyHeader = ({ props }) => {
  const uv = getUsefulVars(props);
  if(uv.resume.industry === undefined) {
    return null;
  }
  return (
    <SurveyHeaderWrapper>
      <BackLink props={props} />
    </SurveyHeaderWrapper>
  );
};

export default SurveyHeader;
